import EstimationStore from './EstimationStore'
import Utils from './Utils'

// 最大階層数
const MAX_CONDITIONS = 10
// 自由入力の選択肢のID
const FREE_INPUT_VALUE = 9

const EstimationActions = {
  setEditableMode (isEditable) {
    EstimationStore.setDataToStorage('EditingMode', isEditable)
  },
  getEditableMode () {
    return EstimationStore.getDataFromStorage('EditingMode')
  },
  getUchiwakeSetting () {
    let UchiwakeSetting = EstimationStore.getDataFromStorage('UchiwakeSetting')
    return UchiwakeSetting
  },
  getHyouzyunGetsugaku (getsugaku, isKenkou) {
    const yearMonth = EstimationActions.getCurrentEstimation().estimationYearMonthId
    const GetsugakuSetting = EstimationStore.getDataFromStorage('GetsugakuSetting')
    let result = ''
    GetsugakuSetting.forEach(setting => {
      if (yearMonth >= setting.startMonth && yearMonth <= setting.endMonth) {
        setting.toukyuuList.forEach(toukyuu => {
          if (getsugaku >= toukyuu.izhou && getsugaku < toukyuu.miman) {
            result = isKenkou ? toukyuu.kenkou : toukyuu.nenkin// あと勝ち
          }
        })
      }
    })
    return result
  },
  updateEstimation (estimationId, estimationData) {
    if(!estimationData) {
      return
    }
    // 見積書のデータを更新
    EstimationStore.setDataToStorage('estimation_' + estimationId, estimationData)
  },
  getEstimation (estimationId) {
    let result = EstimationStore.getDataFromStorage('estimation_' + estimationId)
    return result || {}
  },
  getCurrentEstimation () {
    const data = EstimationStore.getData()
    return EstimationActions.getEstimation(data.currentEstimationId)
  },
  insertUchiwake (offset) {
    offset = Number(offset)
    let estimation = EstimationActions.getCurrentEstimation()
    estimation.uchiwakeList.splice(offset + 1, 0,
      {name: null,
        specification: null,
        suuryou: null,
        tani: null,
        isKatawakuSuuryou: true,
        daikuBugakari: null,
        daikuNinku: null,
        kaitaiBugakari: null,
        kaitaiNinku: null,
        primeContractorUnitPrice: null,
        note: null,
        materialMokuzaiUnitPrice: null,
        meterialMokuzaiNote: null,
        materialShoumouhinUnitPrice: null,
        meterialShoumouhinNote: null,
        materialKouseizaiUnitPrice: null,
        meterialKouseizaiNote: null}
        )
    EstimationActions.updateEstimation(estimation.estimationId, estimation)
  },
  moveUpUchiwake (offset) {
    offset = Number(offset)
    let estimation = EstimationActions.getCurrentEstimation()
    estimation.uchiwakeList.splice(offset - 1, 2, estimation.uchiwakeList[offset], estimation.uchiwakeList[offset - 1])
    EstimationActions.updateEstimation(estimation.estimationId, estimation)
  },
  moveDownUchiwake (offset) {
    offset = Number(offset)
    offset++
    let estimation = EstimationActions.getCurrentEstimation()
    estimation.uchiwakeList.splice(offset - 1, 2, estimation.uchiwakeList[offset], estimation.uchiwakeList[offset - 1])
    EstimationActions.updateEstimation(estimation.estimationId, estimation)
  },
  deleteUchiwake (offset) {
    offset = Number(offset)
    let estimation = EstimationActions.getCurrentEstimation()
    estimation.uchiwakeList.splice(offset, 1)
    EstimationActions.updateEstimation(estimation.estimationId, estimation)
  },
  updateCurrentEstimation (key, newData, callback = false) {
    let estimation = EstimationActions.getCurrentEstimation()
    estimation[key] = newData
    if (callback) {
      estimation = callback(estimation, key, newData)
    }
    const data = EstimationStore.getData()
    EstimationActions.updateEstimation(data.currentEstimationId, estimation)
  },
  updateListInCurrentEstimation (listName, index, attributeName, newData, callback = false) {
    let estimation = EstimationActions.getCurrentEstimation()
    estimation[listName][index][attributeName] = newData
    var list = estimation[listName]
    var suuryou = 0
    for (let i = 0; i < list.length; i++) {
      if (list[i].isKatawakuSuuryou) {
        suuryou += Math.round(list[i].suuryou)
      }
    }
    estimation['estimationKatawakuSuuryou'] = suuryou
    if (callback) {
      estimation = callback(estimation, listName, index, attributeName, newData)
    }
    const data = EstimationStore.getData()
    EstimationActions.updateEstimation(data.currentEstimationId, estimation)
  },
  update (key, newData, callback = false) {
    let data = EstimationStore.getData()
    data[key] = newData
    if (callback) {
      data = callback(data, key, newData)
    }
    EstimationStore.setData(data)
  },
  updateList (listName, index, attributeName, newData, callback = false) {
    let data = EstimationStore.getData()
    data[listName][index][attributeName] = newData
    var list = data[listName]
    var suuryou = 0
    for (let i = 0; i < list.length; i++) {
      if (list[i].isKatawakuSuuryou) {
        suuryou += Math.round(list[i].suuryou)
      }
    }
    data['estimationKatawakuSuuryou'] = suuryou
    if (callback) {
      data = callback(data, listName, index, attributeName, newData)
    }
    EstimationStore.setData(data)
  },
  updateLaborUnitPrice (data, key, value) {
    let laborType = 'daiku'
    if (key.substring(0, 6) === 'kaitai') {
      laborType = 'kaitai'
    }

    let priceType = key.replace(laborType, '').replace('Labor', '').replace('UnitPrice', '')

    const dt = Utils.getDataFromObjectByKeys(data, [
      'laborHonninNenkinRyouritsu',
      'laborHonninKenkouRyouritsu',
      'laborHonninKaigoRyouritsu',
      'laborKoyounushiKodomoRyouritsu',
      'laborHonninKoyouRyouritsu',
      'laborKoyounushiKoyouRyouritsu'
    ], laborType)
    dt.honninRyouritsu = Number(Number(dt.laborHonninNenkinRyouritsu + dt.laborHonninKenkouRyouritsu +
                        dt.laborHonninKaigoRyouritsu + dt.laborHonninKoyouRyouritsu).toFixed(5))
    dt.koyounushiRyouritsu = Number(Number(dt.laborHonninNenkinRyouritsu + dt.laborHonninKenkouRyouritsu + dt.laborHonninKaigoRyouritsu +
                          dt.laborKoyounushiKodomoRyouritsu + dt.laborKoyounushiKoyouRyouritsu).toFixed(5))
    let tedori = value
    let honnin = value
    let hukuri = value

    if (priceType === 'Tedori') {
      honnin = tedori / (1 - dt.honninRyouritsu)
      hukuri = honnin * (1 + dt.koyounushiRyouritsu)
    } else if (priceType === 'Honnin' || priceType === 'Sekkei') {
      tedori = honnin * (1 - dt.honninRyouritsu)
      hukuri = honnin * (1 + dt.koyounushiRyouritsu)
    } else if (priceType === 'Hukuri') {
      honnin = hukuri / (1 + dt.koyounushiRyouritsu)
      tedori = honnin * (1 - dt.honninRyouritsu)
    } else if (priceType === 'Sekkei') {
      tedori = honnin * (1 - dt.honninRyouritsu)
      hukuri = honnin * (1 + dt.koyounushiRyouritsu)
    }
    data[laborType + 'LaborTedoriUnitPrice'] = Number(tedori).toFixed(0)
    data[laborType + 'LaborHonninUnitPrice'] = Number(honnin).toFixed(0)
    data[laborType + 'LaborHukuriUnitPrice'] = Number(hukuri).toFixed(0)
    return data
  },
  getLaborSharedValues (laborType) {
    let data = EstimationActions.getCurrentEstimation()
    const dt = Utils.getDataFromObjectByKeys(data, [
      'laborUnitPriceType',
      'laborUnitPrice',
      'laborWorkDays',
      'laborHonninNenkinRyouritsu',
      'laborHonninKenkouRyouritsu',
      'laborHonninKaigoRyouritsu',
      'laborKoyounushiKodomoRyouritsu',
      'laborHonninKoyouRyouritsu',
      'laborKoyounushiKoyouRyouritsu',
      'laborUnitPriceType',
      'laborTedoriUnitPrice',
      'laborHonninUnitPrice',
      'laborHukuriUnitPrice',
      'laborSekkeiUnitPrice',
      'laborUnitPrice'
    ], laborType)
    dt.honninRyouritsu = dt.laborHonninNenkinRyouritsu + dt.laborHonninKenkouRyouritsu +
                        dt.laborHonninKaigoRyouritsu + dt.laborHonninKoyouRyouritsu
    dt.koyounushiRyouritsu = dt.laborHonninNenkinRyouritsu + dt.laborHonninKenkouRyouritsu + dt.laborHonninKaigoRyouritsu +
                          dt.laborKoyounushiKodomoRyouritsu + dt.laborKoyounushiKoyouRyouritsu
    if (dt.laborUnitPriceType === 'Tedori') {
      const tedori = dt['labor' + dt.laborUnitPriceType + 'UnitPrice']
      const honnin = tedori / (1 - dt.honninRyouritsu)
      dt.laborUnitPrice = Number(honnin).toFixed(0)
    } else if (dt.laborUnitPriceType === 'Honnin') {
      const honnin = dt['labor' + dt.laborUnitPriceType + 'UnitPrice']
      dt.laborUnitPrice = Number(honnin).toFixed(0)
    } else if (dt.laborUnitPriceType === 'Hukuri') {
      const hukuri = dt['labor' + dt.laborUnitPriceType + 'UnitPrice']
      const honnin = hukuri * (1 + dt.honninRyouritsu) / (1 + dt.honninRyouritsu + dt.koyounushiRyouritsu)
      dt.laborUnitPrice = Number(honnin).toFixed(0)
    } else if (dt.laborUnitPriceType === 'Sekkei') {
      const sekkei = dt['labor' + dt.laborUnitPriceType + 'UnitPrice']
      const honnin = sekkei
      dt.laborUnitPrice = Number(honnin).toFixed(0)
    }

    dt.getsugaku = dt.laborUnitPrice * dt.laborWorkDays
    dt.honninNenkinHyouzhunGetsugaku = EstimationActions.getHyouzyunGetsugaku(dt.getsugaku, false)
    dt.honninKenkouHyouzyunGetsugaku = EstimationActions.getHyouzyunGetsugaku(dt.getsugaku, true)

    dt.laborHonninNenkin = dt.honninNenkinHyouzhunGetsugaku * dt.laborHonninNenkinRyouritsu
    dt.laborHonninKenkou = dt.honninKenkouHyouzyunGetsugaku * dt.laborHonninKenkouRyouritsu
    dt.laborHonninKaigo = dt.honninKenkouHyouzyunGetsugaku * dt.laborHonninKaigoRyouritsu
    dt.laborKoyounushiKodomo = dt.honninKenkouHyouzyunGetsugaku * dt.laborKoyounushiKodomoRyouritsu
    dt.laborHonninKoyou = dt.getsugaku * dt.laborHonninKoyouRyouritsu
    dt.laborKoyounushiKoyou = dt.getsugaku * dt.laborKoyounushiKoyouRyouritsu
    dt.honninGoukei = dt.laborHonninNenkin + dt.laborHonninKenkou + dt.laborHonninKaigo + dt.laborHonninKoyou
    dt.koyonusiGoukei = dt.laborHonninNenkin + dt.laborHonninKenkou + dt.laborHonninKaigo +
                          dt.laborKoyounushiKodomo + dt.laborKoyounushiKoyou
    dt.honninDailyHokenRyou = dt.honninGoukei / dt.laborWorkDays
    dt.koyonushiDailyHokenRyou = dt.koyonusiGoukei / dt.laborWorkDays
    return dt
  },
  getEstimationSharedValues () {
    const data = EstimationActions.getCurrentEstimation()
    // 内訳に対する処理
    var uchiwakeList = data.uchiwakeList
    let mokuzaiGoukei = 0
    let shoumouhinGoukei = 0
    let kousezaiGoukei = 0
    let materialUnitPrice = 0
    let katawakuSuuryou = 0
    for (let i = 0; i < uchiwakeList.length; i++) {
      if (uchiwakeList[i].isKatawakuSuuryou) {
        katawakuSuuryou += uchiwakeList[i].suuryou ? parseFloat(uchiwakeList[i].suuryou) : 0
      }
      mokuzaiGoukei += Math.round(uchiwakeList[i].materialMokuzaiUnitPrice * uchiwakeList[i].suuryou)
      shoumouhinGoukei += Math.round(uchiwakeList[i].materialShoumouhinUnitPrice * uchiwakeList[i].suuryou)
      kousezaiGoukei += Math.round(uchiwakeList[i].materialKouseizaiUnitPrice * uchiwakeList[i].suuryou)
    }
    if (!data.materialCostDetailInputMode) {
      mokuzaiGoukei = data.materialMokuzaiUnitPrice * katawakuSuuryou
      shoumouhinGoukei = data.materialShoumouhinUnitPrice * katawakuSuuryou
      kousezaiGoukei = data.materialKouseizaiUnitPrice * katawakuSuuryou
    }
    materialUnitPrice = (mokuzaiGoukei + shoumouhinGoukei + kousezaiGoukei) / katawakuSuuryou

    return {
      materialUnitPrice: isFinite(materialUnitPrice) ? materialUnitPrice : '',
      katawakuSuuryou: isFinite(katawakuSuuryou) ? katawakuSuuryou : ''
    }
  },
  updateNinku (data, listName, index, attributeName, newData) {
    let laborType = 'daiku'
    if (attributeName.substring(0, 6) === 'kaitai') {
      laborType = 'kaitai'
    }
    let dt = data
    if (parseInt(dt[listName][index][laborType + 'Bugakari'])) {
      dt[listName][index][laborType + 'Ninku'] = Number(dt[listName][index]['suuryou'] / dt[listName][index][laborType + 'Bugakari']).toFixed(1)
    } else {
      dt[listName][index][laborType + 'Ninku'] = 0
    }
    return dt
  },
  updateBothNinku (data, listName, index, attributeName, newData) {
    let dt = data
    if (parseInt(dt[listName][index]['daikuBugakari'])) {
      dt[listName][index]['daikuNinku'] = Number(dt[listName][index]['suuryou'] / dt[listName][index]['daikuBugakari']).toFixed(1)
    } else {
      dt[listName][index]['daikuNinku'] = 0
    }
    if (parseInt(dt[listName][index]['kaitaiBugakari'])) {
      dt[listName][index]['kaitaiNinku'] = Number(dt[listName][index]['suuryou'] / dt[listName][index]['kaitaiBugakari']).toFixed(1)
    } else {
      dt[listName][index]['kaitaiNinku'] = 0
    }
    return dt
  },
  updateBugakari (data, listName, index, attributeName, newData) {
    let laborType = 'daiku'
    if (attributeName.substring(0, 6) === 'kaitai') {
      laborType = 'kaitai'
    }
    let dt = data
    dt[listName][index][laborType + 'Bugakari'] = Number(dt[listName][index]['suuryou'] / dt[listName][index][laborType + 'Ninku']).toFixed(1)
    return dt
  },
  selectSekkeiUnitPriceType (data, key, value) {
    let dt = data
    dt = EstimationActions.updateLaborUnitPrice(data, 'daikuLaborSekkeiUnitPrice', dt.daikuLaborSekkeiUnitPrice)
    return dt
  },
  selectPrefecture (data, key, value) {
    const laborSekkeiUnitPirce = EstimationActions.getLaborSekkeiUnitPrice(Number(value) - 1)
    data.daikuLaborSekkeiUnitPrice = laborSekkeiUnitPirce
    let dt = data
    dt = EstimationActions.selectYearMonth(dt, 'estimationYearMonthId', dt['estimationYearMonthId'])
    if (data.daikuLaborUnitPriceType === 'Sekkei') {
      dt = EstimationActions.updateLaborUnitPrice(dt, 'daikuLaborSekkeiUnitPrice', laborSekkeiUnitPirce)
    } else {
      dt = EstimationActions.updateLaborUnitPrice(dt, 'daikuLabor' + data.daikuLaborUnitPriceType + 'UnitPrice', dt['daikuLabor' + data.daikuLaborUnitPriceType + 'UnitPrice'])
    }
    dt = EstimationActions.updateLaborUnitPrice(dt, 'kaitaiLabor' + data.kaitaiLaborUnitPriceType + 'UnitPrice', dt['kaitaiLabor' + data.kaitaiLaborUnitPriceType + 'UnitPrice'])
    return dt
  },
  selectYearMonth (data, key, value) {
    let dt = data
    const NenkinSetting = EstimationStore.getDataFromStorage('NenkinSetting')
    NenkinSetting.forEach(setting => {
      if (value >= setting.startMonth && value <= setting.endMonth) {
        dt['daikuLaborHonninNenkinRyouritsu'] = setting.honninRyouritsu
        dt['kaitaiLaborHonninNenkinRyouritsu'] = setting.honninRyouritsu
      }
    })
    const KoyouSetting = EstimationStore.getDataFromStorage('KoyouSetting')
    KoyouSetting.forEach(setting => {
      if (value >= setting.startMonth && value <= setting.endMonth) {
        dt['daikuLaborHonninKoyouRyouritsu'] = setting.honninRyouritsu
        dt['kaitaiLaborHonninKoyouRyouritsu'] = setting.honninRyouritsu
        dt['daikuLaborKoyounushiKoyouRyouritsu'] = setting.koyounushiRyouritsu
        dt['kaitaiLaborKoyounushiKoyouRyouritsu'] = setting.koyounushiRyouritsu
      }
    })
    const KenkouSetting = EstimationStore.getDataFromStorage('KenkouSetting')
    KenkouSetting.forEach(setting => {
      if (value >= setting.startMonth && value <= setting.endMonth) {
        dt['daikuLaborHonninKenkouRyouritsu'] = setting.ryouritsuList[data.estimationPrefectureId - 1]
        dt['kaitaiLaborHonninKenkouRyouritsu'] = setting.ryouritsuList[data.estimationPrefectureId - 1]
      }
    })
    const KaigoSetting = EstimationStore.getDataFromStorage('KaigoSetting')
    KaigoSetting.forEach(setting => {
      if (value >= setting.startMonth && value <= setting.endMonth) {
        // const ryouritsu =( Math.round(setting.ryouritsu*setting.kanyuuwariai*10000)/10000)/2;//Excelの計算式相当
        const ryouritsu = setting.ryouritsu * setting.kanyuuwariai / 2
        dt['daikuLaborHonninKaigoRyouritsu'] = ryouritsu
        dt['kaitaiLaborHonninKaigoRyouritsu'] = ryouritsu
      }
    })
    const KodomoSetting = EstimationStore.getDataFromStorage('KodomoSetting')
    KodomoSetting.forEach(setting => {
      if (value >= setting.startMonth && value <= setting.endMonth) {
        dt['daikuLaborKoyounushiKodomoRyouritsu'] = setting.ryouritsu
        dt['kaitaiLaborKoyounushiKodomoRyouritsu'] = setting.ryouritsu
      }
    })
    dt.daikuLaborSekkeiUnitPrice = EstimationActions.getLaborSekkeiUnitPrice(data.estimationPrefectureId - 1, value)
    dt = EstimationActions.updateLaborUnitPrice(dt, 'daikuLabor' + data.daikuLaborUnitPriceType + 'UnitPrice', dt['daikuLabor' + data.daikuLaborUnitPriceType + 'UnitPrice'])
    dt = EstimationActions.updateLaborUnitPrice(dt, 'kaitaiLabor' + data.kaitaiLaborUnitPriceType + 'UnitPrice', dt['kaitaiLabor' + data.kaitaiLaborUnitPriceType + 'UnitPrice'])
    return dt
  },
  getLaborSekkeiUnitPrice (prefectureId, yearMonth = false) {
    if (yearMonth === false) {
      yearMonth = EstimationActions.getCurrentEstimation().estimationYearMonthId
    }
    const SekkeiUnitPriceSetting = EstimationStore.getDataFromStorage('SekkeiUnitPriceSetting')
    let sekkeiUnitPrice = 0
    SekkeiUnitPriceSetting.forEach(setting => {
      if (yearMonth >= setting.startMonth && yearMonth <= setting.endMonth) {
        sekkeiUnitPrice = setting.sekkeiUnitPriceList[prefectureId]
      }
    })
    return sekkeiUnitPrice
  },
  updateEstimationConditionValue (index, data, key, value) {
    let estimation = EstimationActions.getCurrentEstimation()

    const conditionKey = `estimationConditions${index}`
    const freeInputKey = `estimationConditionsFree${index}` // 自由記入キーの定義

    // 値を数値化
    let numericValue = Number(value)
    if (isNaN(numericValue)) numericValue = 0

    // 1. 現在のSelectBoxの値を更新
    estimation[conditionKey] = numericValue

    // 2. 自由記入データ (estimationConditionsFreeX) の作成/削除ロジック
    if (numericValue === FREE_INPUT_VALUE) {
      // 選択された値が自由記入 (9) の場合
      // 自由記入キーが存在しない場合は、空文字列で初期化（データを作成）
      if (estimation[freeInputKey] === undefined) {
          estimation[freeInputKey] = '' 
      }
    } else if (estimation[freeInputKey] !== undefined) {
      // 選択された値が自由記入 (9) でないのに、自由記入キーが存在する場合
      // データをクリーンアップのために削除
      delete estimation[freeInputKey]
    }

    // 3. 途中を「選択してください」(ID: 0) に戻した場合の詰め込みロジック
    if (numericValue === 0) {
      let lastShiftedIndex = -1 // 最後にコピー元となったインデックスを記録

      // i: 書き込み先インデックス
      for (let i = index; i < MAX_CONDITIONS - 1; i++) {
        const sourceIndex = i + 1
        const sourceKey = `estimationConditions${sourceIndex}`
        const destKey = `estimationConditions${i}`
        const sourceFreeKey = `estimationConditionsFree${sourceIndex}`
        const destFreeKey = `estimationConditionsFree${i}`

        // 次のキーが存在しない場合は、詰めるデータがないためループを終了
        if (estimation[sourceKey] === undefined) {
            break
        }
        
        // データを i+1 (source) から i (dest) へシフト
        estimation[destKey] = estimation[sourceKey]
        
        // 自由記入データもシフト (undefined も含めてコピー)
        estimation[destFreeKey] = estimation[sourceFreeKey]
        
        lastShiftedIndex = sourceIndex // 最後にデータがあったインデックスを記録
      }

      // シフトが完了した後、最後にコピー元になったキー（重複した最後のキー）を削除する
      if (lastShiftedIndex !== -1) {
          const finalKeyToDelete = `estimationConditions${lastShiftedIndex}`
          const finalFreeKeyToDelete = `estimationConditionsFree${lastShiftedIndex}`

          delete estimation[finalKeyToDelete]
          delete estimation[finalFreeKeyToDelete]
      }
    } else {
      // 選択値が 0 ではない場合、次の空欄を確保するロジック (自動追加)
      const canAddMore = index < MAX_CONDITIONS - 1 
      const nextConditionKey = `estimationConditions${index + 1}`

      if (canAddMore && estimation[nextConditionKey] === undefined) {
          estimation[nextConditionKey] = 0
      }
    }

    EstimationActions.updateEstimation(estimation.estimationId, estimation)
  },
  addEstimationCondition() {
    let estimation = EstimationActions.getCurrentEstimation()
    estimation.estimationConditions = estimation.estimationConditions || []
    if (estimation.estimationConditions.length < 10) {
      estimation.estimationConditions.push({ id: 0 })
      EstimationActions.updateCurrentEstimationValue(estimation)
    }
  }
}
export default EstimationActions



// WEBPACK FOOTER //
// ./src/company_user/libs/EstimationActions.js